export const FETCH_LOGS = 'FETCH_LOGS'
export const FETCH_RETURNING_PART_REASONS = 'FETCH_RETURNING_PART_REASONS'
